// extracted by mini-css-extract-plugin
module.exports = {"botao":"BotaoTabela_botao__Fx9Sh","ativo":"BotaoTabela_ativo__3oykQ","tooltip":"BotaoTabela_tooltip__-FD5z"};